import { takeEvery, put, call } from "redux-saga/effects"
import { toast } from "react-toastify";
import {
  ADD_BROKER_RESOURCE,
  DELETE_BROKER_RESOURCE,
  GET_BROKER_RESOURCE,
  UPDATE_BROKER_RESOURCE,
} from "./actionTypes"
import {
  addBrokerResourceError,
  addBrokerResourceSuccess,
  deleteBrokerResourceError,
  deleteBrokerResourceSuccess,
  getBrokerResourceFail,
  getBrokerResourceSuccess,
  updateBrokerResourceFail,
  updateBrokerResourceSuccess,
} from "./actions"

import {
  deleteBrokerResourseData,
  getBBrokerResourseData,
  postBrokerResourseData,
  updateBrokerResourseData,
} from "../../helpers/backend_helper"

const getBrokerId = () => parseInt(localStorage.getItem('userId'), 10)

const getResourceId = resource => resource?.brokerResourceId || resource?.id

const refreshResources = function* () {
  const response = yield call(getBBrokerResourseData, getBrokerId())
  yield put(getBrokerResourceSuccess(response))
}

const runCallback = (callback, ...args) => {
  if (typeof callback === "function") {
    callback(...args)
  }
}

const showToastError = (toastId, errorMessage) => {
  if (toastId) {
    toast.update(toastId, {
      render: errorMessage,
      type: "error",
      isLoading: false,
      autoClose: 3000,
    })
  } else {
    toast.error(errorMessage)
  }
}

const buildResourcePayload = resource => {
  const payload = {
    resourceTitle: resource.resourceTitle,
    resourceType: parseInt(resource.resourceType, 10),
    agentId: getBrokerId(),
    isActive: resource.isActive !== undefined ? resource.isActive : true,
  }

  if (resource.resourceContent) {
    payload.resourceContent = resource.resourceContent
  }
  if (resource.resourceLink) {
    payload.resourceLink = resource.resourceLink
  }

  return payload
}

function* submitBrokerResource({ payload: { resource, callback } }) {
  let toastId
  try {
    toastId = toast.loading("Please wait...")
    const response = yield call(postBrokerResourseData, buildResourcePayload(resource))
    yield put(addBrokerResourceSuccess(response))
    if (response?.success === true) {
      yield* refreshResources()
      toast.update(toastId, {
        render: "Saved successfully",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      })
      runCallback(callback, true)
    } else {
      const errorMessage =
        response?.validationErrors?.[0] ||
        response?.message ||
        "Some Error. Please try after some time"
      showToastError(toastId, errorMessage)
      yield put(addBrokerResourceError(errorMessage))
      runCallback(callback, false, errorMessage)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Some Error. Please try after some time"
    showToastError(toastId, errorMessage)
    yield put(addBrokerResourceError(errorMessage))
    runCallback(callback, false, errorMessage)
  }
}

function* onBrokerResourceUpdate({ payload: { resource, callback } }) {
  let toastId
  try {
    toastId = toast.loading("Please wait...")
    const resourceId = getResourceId(resource)
    const response = yield call(updateBrokerResourseData, {
      ...buildResourcePayload(resource),
      id: resourceId,
      brokerResourceId: resourceId,
    })
    yield put(updateBrokerResourceSuccess(response))
    if (response?.success === true) {
      yield* refreshResources()
      toast.update(toastId, {
        render: "Resource Updated",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      })
      runCallback(callback, true)
    } else {
      const errorMessage =
        response?.validationErrors?.[0] ||
        response?.message ||
        "Some Error. Please try after some time"
      showToastError(toastId, errorMessage)
      yield put(updateBrokerResourceFail(errorMessage))
      runCallback(callback, false, errorMessage)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Some Error. Please try after some time"
    showToastError(toastId, errorMessage)
    yield put(updateBrokerResourceFail(errorMessage))
    runCallback(callback, false, errorMessage)
  }
}

function* onBrokerResourceDelete({ payload: { resource, callback } }) {
  let toastId
  try {
    toastId = toast.loading("Please wait...")
    const response = yield call(deleteBrokerResourseData, getResourceId(resource))
    yield put(deleteBrokerResourceSuccess(response))
    if (response?.success === true) {
      yield* refreshResources()
      toast.update(toastId, {
        render: "Resource Deleted",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      })
      runCallback(callback, true)
    } else {
      const errorMessage =
        response?.validationErrors?.[0] ||
        response?.message ||
        "Some Error. Please try after some time"
      showToastError(toastId, errorMessage)
      yield put(deleteBrokerResourceError(errorMessage))
      runCallback(callback, false, errorMessage)
    }
  } catch (error) {
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      "Some Error. Please try after some time"
    showToastError(toastId, errorMessage)
    yield put(deleteBrokerResourceError(errorMessage))
    runCallback(callback, false, errorMessage)
  }
}

function* fetchResource({ brokerId }) {
  try {
    const response = yield call(getBBrokerResourseData, brokerId)
    yield put(getBrokerResourceSuccess(response))
  } catch (error) {
    yield put(getBrokerResourceFail(error))
  }
}

function* resourceSaga() {
  yield takeEvery(ADD_BROKER_RESOURCE, submitBrokerResource)
  yield takeEvery(UPDATE_BROKER_RESOURCE, onBrokerResourceUpdate)
  yield takeEvery(DELETE_BROKER_RESOURCE, onBrokerResourceDelete)
  yield takeEvery(GET_BROKER_RESOURCE, fetchResource)
}

export default resourceSaga
